/**
 * @Author：zsj
 * @Date：2022/08/11
 */
import { createContext } from 'react'

export const PermissionCtx = createContext({
    routerArr: [], update: () => {
    }
});
